import i18n from '@/lang';
/* unplugin-vue-components disabled */
import __unplugin_components_1 from 'G:/SVN/单小二/源代码/客户端门户/front/smy-toc-vux-cli3/src/components/ExtField.vue';
import __unplugin_components_0 from 'G:/SVN/单小二/源代码/客户端门户/front/smy-toc-vux-cli3/src/components/ImgUpload.vue';
var render = function () {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c('div', {
    staticClass: "order-execute"
  }, [_c('view-box', {
    ref: "viewBox"
  }, [_vm.template.is_receipt === 1 ? _c('div', {
    staticClass: "container-text"
  }, [_c('group', [_c('cell', {
    attrs: {
      "title": i18n.tc("597"),
      "border-intent": false,
      "arrow-direction": _vm.showContent1 ? 'up' : 'down'
    },
    nativeOn: {
      "click": function ($event) {
        _vm.showContent1 = !_vm.showContent1;
      }
    }
  }, [_c('div', [_c('span', {
    staticStyle: {
      "color": "#3ccba6"
    }
  }, [_vm._v(_vm._s(_vm.showContent1 ? i18n.tc("598") : i18n.tc("599")))])])]), _vm.nodeTmplMap && _vm.nodeTmplMap.r_service_time_view === 1 ? [_c('cell', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: _vm.showContent1,
      expression: "showContent1"
    }],
    attrs: {
      "title": i18n.tc("600"),
      "value": _vm.totalTime
    }
  })] : _vm._e(), _vm.nodeTmplMap && _vm.nodeTmplMap.r_finish_image_view === 1 ? [_c(__unplugin_components_0, {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: _vm.showContent1,
      expression: "showContent1"
    }],
    attrs: {
      "hidden-delete": "",
      "hidden-upload": "",
      "hidden-border": "",
      "title": i18n.tc("601"),
      "value": _vm.imageDescriList.map(function (item) {
        return item.img_url;
      })
    }
  })] : _vm._e()], 2)], 1) : _vm._e(), _vm.ReceiptExtField.length ? _c('group', [_c(__unplugin_components_1, {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: _vm.showContent1,
      expression: "showContent1"
    }],
    ref: "customFormLists",
    staticStyle: {
      "padding": "1rem"
    },
    attrs: {
      "extFields": _vm.ReceiptExtField
    }
  })], 1) : _vm._e(), _vm.template.is_order_charge === 1 ? [_c('div', {
    staticClass: "line"
  }), _c('div', {
    staticClass: "amount"
  }, [_c('div', {
    staticClass: "amount-top",
    on: {
      "click": function ($event) {
        _vm.showContent2 = !_vm.showContent2;
      }
    }
  }, [_c('div', {
    staticClass: "amount-top-text font-size-h3-large"
  }, [_c('span', [_vm._v(i18n.tc("602"))])]), _c('div', {
    staticClass: "amount-top-link font-size-h3-normal"
  }, [_c('div', {
    staticClass: "amount-top-link-text"
  }, [_vm._v(i18n.tc("603") + _vm._s(_vm.service.total_amount || 0) + i18n.tc("604"))]), _c('div', {
    staticClass: "amount-top-link-up font-size-h3-large"
  }, [_vm._v(" " + _vm._s(_vm.showContent2 ? i18n.tc("598") : i18n.tc("599")) + " ")])])]), _vm.showContent2 ? [_c('ServiceAmountTable', {
    attrs: {
      "service": _vm.service,
      "sparePartList": _vm.sparePartList,
      "moneyItemList": _vm.moneyItemList,
      "extServiceItems": _vm.extServiceItems
    }
  })] : _vm._e()], 2)] : _vm._e(), _vm.template.is_receipt === 1 ? [_c('div', {
    staticClass: "container-operation"
  }, [_c('group', [_vm.template.is_receipt_valid === 1 ? _c('cell', {
    attrs: {
      "title": i18n.tc("605"),
      "border-intent": false,
      "value": _vm.orderInfo.receipt_valid_code || ''
    }
  }) : _vm._e(), _vm.template.is_receipt_sign === 1 ? [_c('cell', {
    attrs: {
      "title": i18n.tc("606"),
      "border-intent": false,
      "value": _vm.service.receipt_createtime || ''
    }
  }), _c('cell', {
    attrs: {
      "title": i18n.tc("321"),
      "border-intent": false
    }
  }, [_c('div', {
    staticStyle: {
      "color": "#eb524a"
    },
    attrs: {
      "slot": "icon"
    },
    slot: "icon"
  }, [_c('span', {
    staticStyle: {
      "vertical-align": "middle"
    }
  }, [_vm._v("*")])]), !_vm.service.sign ? _c('span', {
    staticStyle: {
      "color": "#3ccba6"
    },
    on: {
      "click": function ($event) {
        _vm.writeShow = true;
      }
    }
  }, [_vm._v(i18n.tc("322"))]) : _vm._e()]), [!_vm.service.sign ? _c('div', {
    staticClass: "signature font-size-h3-large",
    on: {
      "click": function ($event) {
        _vm.writeShow = true;
      }
    }
  }, [_vm._v(" " + i18n.tc("323") + " ")]) : _c('div', {
    staticClass: "signature font-size-h3-large"
  }, [_c('img', {
    attrs: {
      "src": _vm.service.sign
    }
  }), _c('p', [_vm._v(i18n.tc("324"))])])]] : _vm._e()], 2)], 1)] : _vm._e(), _c('WriteExecute', {
    attrs: {
      "default-event": false
    },
    on: {
      "on-success": _vm.uploadSign
    },
    model: {
      value: _vm.writeShow,
      callback: function ($$v) {
        _vm.writeShow = $$v;
      },
      expression: "writeShow"
    }
  })], 2)], 1);
};
var staticRenderFns = [];
export { render, staticRenderFns };